import {AfterViewChecked, ChangeDetectorRef, Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {FlexLayoutItem} from '../flex-layout-item';
import {DynamicFormService} from '../../../dynamic-form/dynamic-form.service';
import {UntypedFormGroup} from '@angular/forms';
import {FieldConfigWrapper} from '../../../dynamic-field/field-config-wrapper';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';


@UntilDestroy()
@Component({
    selector: 'mydocma-dynamic-form-layout-item',
    styleUrls: ['flex-layout-item.component.scss'],
    templateUrl: './flex-layout-item.component.html'
})
export class FlexLayoutItemComponent implements OnChanges, OnDestroy, OnInit {


    @Input()
    public gridItem: FlexLayoutItem;

    public fieldWrapper: FieldConfigWrapper<any>;

    public formGroup: UntypedFormGroup;


    constructor(private readonly dynamicFormService: DynamicFormService, private cdRef: ChangeDetectorRef) {
    }

    ngOnInit(): void {
        this.fieldWrapper?.onUpdated.pipe(untilDestroyed(this))
            .subscribe((value) => {
                this.updateItemVisibility(value);

            });
    }

    /**
     * A lifecycle hook that is called when any data-bound property of a directive changes.
     *
     * @param changes - changes
     */
    public ngOnChanges(changes: SimpleChanges) {
        if (changes.gridItem) {
            this.formGroup = this.dynamicFormService.formGroup;
            this.dynamicFormService.fieldWrappers.forEach((fieldConfigWrapper: FieldConfigWrapper<any>) => {
                if (fieldConfigWrapper.config.name === this.gridItem.name) {
                    this.fieldWrapper = fieldConfigWrapper;
                    this.updateItemVisibility(fieldConfigWrapper.config);
                }
            });
        }
    }

    ngOnDestroy(): void {
    }

    private updateItemVisibility(config): void {
        const isClassExist = this.gridItem.class?.includes('mydocma-hidden-layout-item');
        if (config.hidden && !isClassExist) {
            this.gridItem.class += ' mydocma-hidden-layout-item';
            return;
        }
        if (!config.hidden && isClassExist) {
            this.gridItem.class = this.gridItem.class.replace('mydocma-hidden-layout-item', '');
        }
    }
}

